<template>
    <div class="login-page-container">
        <div class="login-page">
            <world-map :feed="feed" :shouldDisplayGrid="true" @updateThreatWatch="updateThreatWatch"
            :newFeedDisplayInterval="newFeedDisplayInterval"></world-map>
            <threat-watch id="threat-watch" ref="threatWatch"></threat-watch>
            <p id="login-title">Valkyrie <br/> Threat Intelligence</p>
            <p id="login-sub-title">Malware Threats in Realtime</p>
        </div>
    </div>
</template>

<script>

    import WorldMap from '@/components/world-map/WorldMap.vue'
    import ThreatWatch from '@/components/threat-watch/ThreatWatch.vue'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'

    export default {
        name: "rsa-map",
        components: {
            WorldMap: WorldMap,
            ThreatWatch: ThreatWatch,
        },
        mixins: [Common],
        data() {
            return {
                feed: [],

                id: 0,
                message_id: '',

                isLoading: false,
                registerHash: null,

                newFeedDisplayInterval: 0

            }
        },
        methods: {
            updateThreatWatch(data) {
                this.$refs.threatWatch.updateValues(data.virusPercent, data.trojanPercent, data.avgThreatLevel);
            },
            fetchNewFeedData() {
                var path = Constants.BACKEND_URL + '/threat/flow/all-malware-files';
                var params = {};
                if (this.latestTimestamp)
                    params.latestTimestamp = this.latestTimestamp;

                this.$http.get(path, {params: params})
                    .then(response => {
                        this.feed = this.feed.concat(response.body);
                        if (this.feed && this.feed.length > 0)
                            this.latestTimestamp = this.feed[this.feed.length - 1].timestamp;

                        this.newFeedDisplayInterval = Math.ceil(1000 / (this.feed.length / 300));
                    }, response => {
                    });
            },
            periodicallyFetchNewFeedData() {
                var self = this;
                this.fetchNewFeedData();
                setInterval(() => {
                    self.fetchNewFeedData();
                }, 1000 * 60 * 5);
            }
        },
        computed: {
        },
        mounted() {
            this.periodicallyFetchNewFeedData();
        }
    }

</script>

<style scoped>

    .login-page-container {
        width: 100vw;
        height: 100vh;
    }

    .login-page {
        width: 100vw;
        height: 100vh;
        min-width: 1280px !important;
        min-height: 720px !important;
        overflow: auto;
        position: relative;
    }

    #login-button {
        font-family: 'Digital-Serial-Bold';
        width: 9.4791%;
        height: 7.8%;
        background-color: rgba(0, 255, 169, 1);
        border: 1px solid rgba(0, 255, 169, 1);
        border-radius: 2px;
        position: absolute;
        top: 28.5%;
        right: 5.2%;
        font-size: 1.5em;
        color: rgba(52, 63, 73, 1);
        cursor: pointer;

        animation-duration: 2s;
        animation-name: heartbeat;
        animation-iteration-count: infinite;

        -webkit-backface-visibility: hidden;
    }

    #login-title {
        font-family: 'Digital-Serial-Regular';
        position: absolute;
        top: 6%;
        left: 4%;
        font-size: 3.2em;
        color: rgba(0, 255, 169, 1);
        text-shadow: 0em 0em 0.375em rgba(0, 255, 169, 1);
    }

    #login-sub-title {
        font-family: 'Digital-Serial-Regular';
        position: absolute;
        bottom: 6%;
        right: 4%;
        font-size: 1em;
        color: rgba(0, 255, 169, 1);
        text-shadow: 0em 0em 0.375em rgba(0, 255, 169, 1);
    }

    #threat-watch {
        position: absolute;
        top: calc(58.7% + (35.2% - 16vw) / 2);
        left: 9.0729%;
        width: 15.5vw;
        height: 15.5vw;
        min-width: 200px;
        min-height: 200px;
        padding-left: 0%;
    }

    .login-input {
        background-color: transparent;
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Bold';
        font-size: 1.125em;
        text-align: center;
        border: none;
        width: 12.6458%;
        position: absolute;
        right: 3.7%;
        top: 20.5%;
        line-height: 18px;
    }

    .login-input::placeholder {
        color: rgba(1, 100, 79, 1);
        font-family: 'Digital-Serial-Bold';
    }

    #loginLine {
        display: block;
        height: 1px;
        border: 0;
        margin: 0;
        border-top: 1px solid rgba(0, 255, 169, 1);
        padding: 0;
        width: 13.6458%;
        position: absolute;
        right: 3.5%;
        top: 23.4%;
    }

    #lblNotifier {
        color: rgba(0, 255, 169, 1);
        font-family: 'Digital-Serial-Regular';
        position: absolute;
        top: 42%;
        left: 84%;
        width: 12%;
        height: 8%;
    }

    #loginLogo {
        position: absolute;
        right: 8.3%;
        top: 3%;
    }

    @keyframes heartbeat {
        0% {
            transform: scale(.9);
        }
        20% {
            transform: scale(1);
        }
        40% {
            transform: scale(.9);
        }
        60% {
            transform: scale(1);
        }
        80% {
            transform: scale(.9);
        }
        100% {
            transform: scale(.9);
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Map.vue